"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var checkIsBetslipOddActive_1 = __importDefault(require("./checkIsBetslipOddActive"));
function checkIsOddActiveByEntities(_a) {
    var oddId = _a.oddId, odds = _a.odds, marketId = _a.marketId, markets = _a.markets, sportEventId = _a.sportEventId, matches = _a.matches;
    var odd = odds.get(oddId);
    if (!odd)
        return false;
    var status = odd.status, isActive = odd.isActive;
    var market = markets.get(marketId);
    if (!market)
        return false;
    var match = matches.get(sportEventId);
    if (!match)
        return false;
    return checkIsBetslipOddActive_1.default(match.status, match.disabled, market.status, status, isActive, match.betStop);
}
exports.default = checkIsOddActiveByEntities;
//# sourceMappingURL=checkIsOddActiveByEntities.js.map